export default __webpack_public_path__ + "static/en-map-9da45fdc87b5dad989e44f1a22f8b04a.png";